/* global graphql  */
import PropTypes from 'prop-types'
import React from 'react'
import Header from '../components/header-new'
import Footer from '../components/footer-new'
import FactLoader from '../components/fact-loader'

const NotFoundPage = ({ data }) => (
  <div className='wrapper--page-dark page--404'>
    <div className='page-main'>
      <Header />
      <div className='wrapper--max-width'>
        <header className='page-header'>
          <h1>Oops, that doesn't exist</h1>
          <p>We can't find the page you were looking for.</p>
        </header>
        <FactLoader facts={data.allDrupalFact.edges} />
      </div>
    </div>
    <Footer theme='dark' />
  </div>
)

export default NotFoundPage

NotFoundPage.propTypes = {
  data: PropTypes.object
}

export const query = graphql`
  query FactsQuery {
    allDrupalFact {
      edges {
        node {
          header
          fact
          link {
            title
            url {
              path
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/404.js